// Limit-reached invite CTA — appears when free users exhaust their monthly quota.
// Two escape hatches: upgrade to Pro, or invite friends for bonus credits (PLG).
import { motion, AnimatePresence, Link, Sparkles, Zap, Share2 } from "@/pages/shared";

export const LimitReachedModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4" onClick={onClose} data-testid="limit-modal">
        <motion.div initial={{ scale: 0.95, y: 10 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 10 }} className="glass border border-violet-500/30 rounded-2xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
          <div className="text-center mb-5">
            <div className="w-14 h-14 mx-auto rounded-full bg-violet-500/20 flex items-center justify-center mb-3">
              <Sparkles className="w-7 h-7 text-violet-400" />
            </div>
            <h2 className="text-xl font-bold mb-1">You've used all your credits this month</h2>
            <p className="text-sm text-muted-foreground">Two ways to keep generating:</p>
          </div>
          <div className="space-y-3">
            <Link to="/dashboard/settings" onClick={onClose} className="block p-4 rounded-xl bg-gradient-to-r from-violet-600 to-violet-700 hover:from-violet-500 hover:to-violet-600 transition-colors" data-testid="limit-upgrade-link">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-white">Upgrade to Pro — £29/mo</p>
                  <p className="text-xs text-violet-100/80 mt-0.5">100 generations + unlimited everything</p>
                </div>
                <Zap className="w-6 h-6 text-white" />
              </div>
            </Link>
            <Link to="/dashboard/referrals" onClick={onClose} className="block p-4 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-testid="limit-invite-link">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold">Invite 2 friends → +10 credits</p>
                  <p className="text-xs text-muted-foreground mt-0.5">Free. They get 5 credits too.</p>
                </div>
                <Share2 className="w-6 h-6 text-cyan-400" />
              </div>
            </Link>
          </div>
          <button onClick={onClose} className="w-full mt-4 text-xs text-muted-foreground hover:text-foreground" data-testid="limit-dismiss">Maybe later</button>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
